import React from 'react';
import classNames from 'classnames';
import { func, string, bool, number } from 'prop-types';

import './TextInput-style.css';

class TextInput extends React.Component {
    static propTypes = {
        value: string,
        name: string,
        placeholder: string,
        className: string,
        inputClass: string,
        autofocus: bool,
        disabled: bool,
        onChange: func,
        maxLength: number
    };

    onInput = event => {
        const { onChange } = this.props;

        onChange(event.target.value);
    };

    componentDidMount() {
        const { autofocus } = this.props;

        if (autofocus) {
            this.input.focus();
        }
    }

    render() {
        const {
            value = '',
            className,
            inputClass = '',
            placeholder,
            name,
            rows,
            autofocus,
            disabled,
            maxLength
        } = this.props;
        const componentClass = classNames('text-input', className);

        return (
            <div className={componentClass}>
                {!rows && (
                    <input
                        ref={input => {
                            this.input = input;
                        }}
                        disabled={disabled}
                        type="text"
                        className={inputClass}
                        value={value}
                        placeholder={placeholder}
                        name={name}
                        maxLength={maxLength}
                        onChange={this.onInput}
                        onKeyDown={this.onKeyDown}
                        autoFocus={autofocus}
                    />
                )}

                {rows && (
                    <textarea
                        ref={input => {
                            this.input = input;
                        }}
                        className={inputClass}
                        rows={rows}
                        value={value}
                        placeholder={placeholder}
                        name={name}
                        disabled={disabled}
                        maxLength={maxLength}
                        onChange={this.onInput}
                        onKeyDown={this.onKeyDown}
                        autoFocus={autofocus}
                    />
                )}
            </div>
        );
    }
}

export default TextInput;
